export const callZohoFlow = async (params: object) : Promise<any> => {
    const response = await fetch('https://www.websiteforge.com/custom/chosen_signup_form.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
    });
    if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
    }
};